import { render, staticRenderFns } from "./recommended_edit.vue?vue&type=template&id=39123fa0&scoped=true&"
import script from "./recommended_edit.vue?vue&type=script&lang=js&"
export * from "./recommended_edit.vue?vue&type=script&lang=js&"
import style0 from "./recommended_edit.vue?vue&type=style&index=0&id=39123fa0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39123fa0",
  null
  
)

export default component.exports